import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectOfferChilds = state => state.get('offerChilds', initialState);

const makeSelectMonthlyRate = () =>
  createSelector(selectOfferChilds, offerChildsState =>
    offerChildsState.get('monthlyRate'),
  );

const makeSelectDuration = () =>
  createSelector(selectOfferChilds, offerChildsState =>
    offerChildsState.get('duration'),
  );

const makeSelectDeposit = () =>
  createSelector(selectOfferChilds, offerChildsState =>
    offerChildsState.get('deposit'),
  );

const makeSelectDistance = () =>
  createSelector(selectOfferChilds, offerChildsState =>
    offerChildsState.get('distance'),
  );

const makeSelectSecondDistance = () =>
  createSelector(selectOfferChilds, offerChildsState =>
    offerChildsState.get('secondDistance'),
  );

const makeSelectThirdDistance = () =>
  createSelector(selectOfferChilds, offerChildsState =>
    offerChildsState.get('thirdDistance'),
  );

const makeSelectChildOffers = () =>
  createSelector(selectOfferChilds, offerChildsState =>
    offerChildsState.get('offers'),
  );

const makeSelectHasError = () =>
  createSelector(selectOfferChilds, offerChildsState =>
    offerChildsState.get('hasError'),
  );

const makeSelectErrorMsg = () =>
  createSelector(selectOfferChilds, offerChildsState =>
    offerChildsState.get('errorMsg'),
  );

const makeSelectIsLoading = () =>
  createSelector(selectOfferChilds, offerChildsState =>
    offerChildsState.get('loading'),
  );

const makeSelectChildEditing = () =>
  createSelector(selectOfferChilds, offerChildsState =>
    offerChildsState.get('editMode'),
  );

export {
  selectOfferChilds,
  makeSelectMonthlyRate,
  makeSelectDuration,
  makeSelectDeposit,
  makeSelectDistance,
  makeSelectSecondDistance,
  makeSelectThirdDistance,
  makeSelectChildOffers,
  makeSelectHasError,
  makeSelectErrorMsg,
  makeSelectIsLoading,
  makeSelectChildEditing,
};
